enum MenuSectionPriceDisplay {
  Default = 1,
  HidePriceOptions = 2,
}

export { MenuSectionPriceDisplay };
